/**
 * Endkundenrechner API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum Gebaeudetyp {

    Einfamilienhaus = 'Einfamilienhaus',

    Doppelhaushaelfte = 'Doppelhaushaelfte',

    Zweifamilienhaus = 'Zweifamilienhaus',

    Reihenhaus = 'Reihenhaus',

    Mehrfamilienhaus = 'Mehrfamilienhaus'
}

